const root: HTMLElement = document.getElementById('root') as HTMLElement;

export default root;
